import { ListBullets } from '@phosphor-icons/react';

export default ListBullets;
